module.exports = __webpack_public_path__ + "static/media/universal-access.1194d8d3.svg";